export default "__VITE_ASSET__DlhpgPVl__"